import React from "react";
import { useField } from "formik";
import FieldError from "./FieldError";

const FormikSelectField = ({
  label,
  options,
  placeholder = "Seleccione una opción",
  required = false,
  ...props
}) => {
  const [field, meta] = useField(props.name);
  const errorId = `${props.name}-error`;
  const hasError = Boolean(meta.touched && meta.error);
  const selectedLabel =
    options.find((option) => option.value === field.value)?.label || placeholder;

  return (
    <div className="form-group registration-field">
      {label && (
        <label htmlFor={props.name}>
          {label} {required && <span aria-hidden="true">*</span>}
        </label>
      )}
      <div
        className={`registration-select-wrapper${
          hasError ? " is-invalid" : ""
        }`}
      >
        <span
          className={`registration-select-value${
            field.value ? "" : " is-placeholder"
          }`}
          aria-hidden="true"
        >
          {selectedLabel}
        </span>
        <select
          {...field}
          {...props}
          id={props.name}
          className="registration-select"
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
        >
          <option value="">{placeholder}</option>
          {options.map(({ label: optionLabel, value }) => (
            <option key={value} value={value}>
              {optionLabel}
            </option>
          ))}
        </select>
      </div>
      <FieldError id={errorId} error={meta.error} touched={meta.touched} />
    </div>
  );
};

export default FormikSelectField;
